import { perthnow } from './perthnow'
import { sevennews } from './sevennews'
import { thewest } from './thewest'
import { DesignTokens } from './types'

export * from './types'
export const tokens: DesignTokens = {
    thewest,
    perthnow,
    sevennews,
}
